import dayjs from 'dayjs';
import { useEffect } from 'react';

import { isSelfHosted } from '@/utils/is-self-hosted';

import { useAuth } from './useAuth/useAuth';
import { useCurrentOrganization, useUser } from './useSwr';

type WindowWithDelighted = Window & typeof globalThis & { delighted: any };

export const useDelightedSurvey = () => {
  const { session } = useAuth();
  const { data: user } = useUser();
  const currentOrg = useCurrentOrganization();

  const { email } = session?.user ?? {};
  const { user: userData } = user?.data ?? {};
  const { user_metadata } = userData ?? {};
  const { display_name: company } = currentOrg?.data ?? {};
  const delighted = (window as WindowWithDelighted).delighted;

  useEffect(() => {
    if (isSelfHosted) return;
    if ((email || user_metadata?.email) && delighted) {
      const createdDay = dayjs(userData?.created_at);
      const lastSignInDay = dayjs(userData?.last_sign_in_at);
      const daysSinceCreated = dayjs().diff(createdDay, 'day');
      const daysSinceLastSignIn = dayjs().diff(lastSignInDay, 'day');

      if (
        // first condition is for when user is new, we create their profile in delighted
        // this is fine if the user reloads the page because on the delighted side we also have a 3 months delay before showing
        // the survey.
        daysSinceCreated === 0 ||
        // second condition is for when user account was created more than 90 days ago and have last signed in in the last 10 days,
        // we send the actual survey. Hopefully this indicates they've used the product.
        (daysSinceCreated > 90 && daysSinceLastSignIn < 10)
      ) {
        delighted.survey({
          email: email ?? user_metadata?.email,
          name: user_metadata?.full_name,
          createdAt: userData?.created_at,
          // not sure if properties is actually getting propogated through correctly to Delighted
          properties: {
            company,
          },
        });
      }
    }
  }, [email, user_metadata, company, delighted, userData]);

  return null;
};
